import { createService } from './utils';
import sendContactRequest, { SendContactRequestDataSchema } from '~controllers/service/contact';
export default () => {
    const contactService = createService('contact', 'contactId');
    const useSendContactRequest = contactService.addCreateMutation({
        controller: sendContactRequest,
        schema: SendContactRequestDataSchema,
        middleware: [],
    });
    return {
        service: contactService,
        hooks: {
            useSendContactRequest,
        },
    };
};
